import { Component } from '@angular/core';
import { EntityCrud } from '../../../shared/working/entity-crud/entity-crud';
import { ENTITY_CONFIGS } from '../entity-configs';

@Component({
  imports: [EntityCrud],
  selector: 'app-md-b64883b6',
  styleUrl: './md-b64883b6.css',
  templateUrl: './md-b64883b6.html',
})
export class MdB64883b6 {
  readonly config = ENTITY_CONFIGS['b64883b6'];
}
